<template>
    <div style="position: relative">
        <p-inc-todo-card
            :item       = "item"
            :show-date  = "true"
            :date       = "item.dateRemedyOfDefects"
            :date-color = "prioColor"
            :height     = "114"
        >
            <template v-slot:comment>
                <v-divider class="mt-1 mb-1" />
                <div class="v-flex pr-4" style="margin-top: 2px;">
                    <p-inc-assessment-card-faults
                        type       = "major"
                        :faults    = "item.majorFaults"
                        :confirmed = "item.majorFaultsConfirmed"
                    />

                    <p-inc-assessment-card-faults
                        type       = "middle"
                        :faults    = "item.middleFaults"
                        :confirmed = "item.middleFaultsConfirmed"
                    />

                    <p-inc-assessment-card-faults
                        type       = "minor"
                        :faults    ="item.minorFaults"
                        :confirmed = "item.minorFaultsConfirmed"
                    />

                    <v-spacer />

                    <div class="assessment-date">
                        <div class="v-flex">
                            <div class="assessment-date-label">Prüfung am:</div><div>{{ dateAsString (item.date) }}</div>
                        </div>
                        <div class="v-flex">
                            <div class="assessment-date-label">Bearbeitet am:</div><div>{{ dateAsString (item.modifiedDate) }}</div>
                        </div>
                    </div>
                </div>
            </template>
        </p-inc-todo-card>
    </div>
</template>
<script>

import PIncTodoCard     from "@/modules/inc/todos/components/private/PIncTodoCard.vue";
import IncTodoCardMixin from "@/modules/inc/todos/components/mixins/IncTodoCardMixin";
import PIncAssessmentCardFaults from "@/modules/inc/todos/components/private/PIncAssessmentCardFaults.vue";

export default {
    name: "PIncAssessmentCard",

    components: {
        PIncAssessmentCardFaults,
        PIncTodoCard,
    },

    mixins: [
        IncTodoCardMixin
    ],

    props: {
        item: {
            default: () => {
                return {
                    stateColor: null,
                    minorFaults: 0,
                    minorFaultsConfirmed: 0,
                    middleFaults: 0,
                    middleFaultsConfirmed: 0,
                    majorFaults: 0,
                    majorFaultsConfirmed: 0
                }
            }
        },

        result: {

        }
    },

    computed: {
        prioColor () {
            switch (this.item.prio) {
                case 1: return "error white--text";
                case 2: return "warning white--text"
                case 3: return "success white--text"
            }

            return "white grey--text lm-border"
        }
    },

    methods: {
        textColor () {
            if (this.delay >= 14) {
                return "error--text"
            }

            return 'primary--text';
        }
    }
}
</script>

<style scoped>

.assessment-date {
    width: 156px;
    padding-left: 0;
    font-size: 13px;
    text-align: left;
    margin-top: 6px;
}

.assessment-date-label {
    width: 90px;
}

</style>